<!-- 机构评价 -->
<template>
  <div class="app-container">
    <el-form v-model="queryForm" :inline="true" class="query-form">
      <el-form-item>
        <el-input v-model="queryForm.content" clearable type="text" placeholder="请输入查询关键字" />
      </el-form-item>
      <el-form-item>
        <el-select v-model="queryForm.isShow" placeholder="请选择状态">
          <el-option v-for="item in queryOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-button type="primary" @click="handleSearch">
        <i class="el-icon-search" />查询
      </el-button>
      <el-button type="default" @click="reset">
        <i class="el-icon-refresh" />重置刷新
      </el-button>
    </el-form>

    <el-table v-loading="table.listLoading" :data="table.items" element-loading-text="Loading" border stripe fit highlight-current-row @sort-change="sort">
      <!-- <el-table-column label="id" prop="id" sortable /> -->
      <el-table-column label="门店名称" prop="org">
        <template slot-scope="scope">{{scope.row.org.displayName}}</template>
      </el-table-column>
      <el-table-column label="评价内容" prop="content" />
      <el-table-column label="评论人" prop="creatorUser">
        <template slot-scope="scope">{{scope.row.creatorUser | getCreateUser}}</template>
      </el-table-column>

      <el-table-column label="创建时间" prop="creationTime">
        <template slot-scope="scope">{{ scope.row.creationTime | formatDate }}</template>
      </el-table-column>

      <el-table-column label="状态" prop="isShow">
        <template slot-scope="scope">
          <el-tag :type="tagColor(scope.row.isShow)">{{ scope.row.isShow | getStatus }}</el-tag>
        </template>
        <!-- <template slot-scope="scope">{{scope.row.isShow | getStatus}}</template> -->
      </el-table-column>

      <el-table-column label="操作" width="170">
        <template slot-scope="scope">
          <el-button size="mini" type="warning" v-if="scope.row.isShow" @click="handleHidden(scope.$index, scope.row)">隐藏</el-button>
          <el-button size="mini" type="success" v-if="!scope.row.isShow" @click="handleDisplay(scope.$index, scope.row)">显示</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination :current-page.sync="table.page" :page-sizes="[10, 20, 50, 100]" :page-size="table.pagesize" layout="total,jumper,prev, pager, next,sizes" :total="table.totalCount" @size-change="handleSizeChange" @current-change="current_change" />
  </div>
</template>

<script>
const controller = "ou";
export default {
  data() {
    return {
      formDateMonth: "",
      dateMonth: "",
      textMap: {
        update: "编辑",
        create: "创建"
      },
      table: {
        items: [],
        listLoading: true,
        pagesize: 20,
        page: 1,
        totalCount: 0,
        sorting: "id desc"
      },
      queryForm: {
        content: "",
        isShow: null,
        organizationUnitId: ""
      },
      queryOptions: [
        {
          value: null,
          label: "全部"
        },
        {
          value: true,
          label: "显示"
        },
        {
          value: false,
          label: "隐藏"
        }
      ],
      detail: {},
      dialogShow: false,
      storesList: []
    };
  },
  computed: {
    formTitle() {
      return "退款订单详情";
    }
  },
  filters: {
    getCreateUser(cell) {
      if (cell) {
        return cell.name;
      }
      return "";
    },
    getStatus(cell) {
      if (cell) {
        return "显示";
      }
      return "隐藏";
    }
  },
  created() {
    this.fetchData(); // 如果开启了默认排序,不需要这一行
    this.fetchStores();
  },
  methods: {
    fetchStores() {
      let that = this;
      this.$abpApi.client.getStores().then(res => {
        this.storesList = res;
      });
    },
    //
    handleMenu($row) {
      switch ($row.type) {
        case "hidden": {
          this.handleHidden($row.index, $row.item);
          return;
        }
        case "display": {
          this.handleDisplay($row.index, $row.item);
          return;
        }
      }
    },
    reset() {
      this.queryForm.content = "";
      this.queryForm.isShow = null;
      this.fetchData(1);
    },
    fetchData(page = 1) {
      this.table.listLoading = true;
      this.queryForm.SkipCount = (page - 1) * this.table.pagesize;
      this.queryForm.sorting = this.table.sorting;
      this.queryForm.maxResultCount = this.table.pagesize;
      this.queryForm.year = this.$getCaption(this.dateMonth, 0);
      this.queryForm.month = this.$getCaption(this.dateMonth, 1);
      this.$abpApi[controller]
        .getOrganizationUnitCommentList(this.queryForm)
        .then(response => {
          this.table.items = response.data.items;
          this.table.totalCount = response.data.totalCount;
          this.table.listLoading = false;
        });
    },
    // 切换切面,在watch中监听 page
    current_change(e) {
      this.table.page = e;
      this.fetchData(e);
    },
    // 排序
    sort(e) {
      console.log("sort : ", e);
      if (e.prop && e.order) {
        this.table.sorting = `${e.prop} ${e.order}`;
      } else {
        this.table.sorting = "id descending";
      }
      this.fetchData(1);
    },
    handleSizeChange(e) {
      this.table.pagesize = e;
      this.fetchData(1);
    },
    handleSearch() {
      this.fetchData(1);
    },
    handleCreateNew() {
      this.$router.push({
        name: "payrollAssignCreate"
      });
    },
    jumpDetail(index, row) {
      var that = this;
      const id = row.id;
      this.$router.push({
        name: "payrollAssignDetail",
        params: {
          id: id
        }
      });
    },
    handleEdit(index, row) {
      var that = this;
      const id = row.id;
      this.$router.push({
        name: "payrollAssignEdit",
        params: {
          id: id
        }
      });
      //   this.$abpApi[controller]
      //     .get({
      //       id: row.id
      //     })
      //     .then(res => {
      //       that.form.data = res
      //       that.form.show = true
      //       that.dialogStatus = 'update'
      //     })
    },
    handleDelete(index, row) {
      this.$confirm("您确认要删除此项吗？").then(() => {
        this.$abpApi[controller]
          .deleteComment({
            id: row.id
          })
          .then(res => {
            this.fetchData();
            this.$message({
              type: "success",
              message: "删除成功"
            });
          });
      });
    },
    handleHidden(index, row) {
      this.$confirm("您确认要隐藏此项吗？").then(() => {
        this.$abpApi[controller]
          .hideComment({
            id: row.id
          })
          .then(res => {
            this.fetchData();
            this.$message({
              type: "success",
              message: "操作成功"
            });
          });
      });
    },
    handleDisplay(index, row) {
      this.$confirm("您确认要显示此项吗？").then(() => {
        this.$abpApi[controller]
          .showComment({
            id: row.id
          })
          .then(res => {
            this.fetchData();
            this.$message({
              type: "success",
              message: "操作成功"
            });
          });
      });
    },
    handleSave() {
      this.$refs["dataForm"].validate(valid => {
        if (valid) {
          console.log(this.form.data);
          let fn;
          if (this.form.data.id) {
            fn = this.$abpApi[controller].update;
          } else {
            fn = this.$abpApi[controller].create;
          }
          fn(this.form.data).then(res => {
            this.form.submitting = false;
            this.form.show = false;
            this.fetchData();
          });
        }
      });
    },
    tagColor(isShow) {
      switch (isShow) {
        case false:
          return "danger";
        case true:
          return "success";
        default:
          return "";
      }
    }
  }
};
</script>

<style scoped lang="scss">
.refund-detail {
  > div {
    margin: 12px 0;
  }
}
</style>
